module.exports = __webpack_public_path__ + "img/arrow-right.3a3b4db6.svg";